import Marquee from "react-fast-marquee";

const ITEMS = [
  "Warranty Guaranteed",
  "Fast Turnaround",
  "Genuine Parts",
  "No-fix No-fee",
  "Walk-ins Welcome",
  "Trade-in Friendly",
  "Free Diagnosis Estimate",
];

export default function TrustMarquee() {
  return (
    <div className="marquee-yellow py-4" data-testid="trust-marquee">
      <Marquee speed={60} gradient={false} pauseOnHover>
        {ITEMS.concat(ITEMS).map((item, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-8 font-mono-ez text-sm font-bold uppercase tracking-widest text-[#0A0A0A]"
          >
            <span>★</span>
            <span>{item}</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
